import {Injectable} from "@angular/core";
import {UpgradeModule} from "@angular/upgrade/static";

@Injectable({
    providedIn: "root",
})
export class StateService {
    state;

    constructor(private upgrade: UpgradeModule) {
        this.state = upgrade.injector.get("$state");
    }

    public go(url: string): void {
        this.state.go(url);
    }
}
